import * as Yup from "yup";
import checkout from "./form";

const {
  formField: {
    taxCalculationPeriod,
    firstTime,
    caseAccounting,
    taxAgencyId,
    taxAgencyName,
    supplementaryForThe,
    taxpayerName,
    taxId1,
    checkbox1,
    certificate,
    signer,
    fullName,
    timeSign,
  },
} = checkout;

const validation = Yup.object().shape({
  [fullName.name]: Yup.string().required(fullName.errorMsg),
  [taxAgencyName.name]: Yup.string().optional(),
  [taxAgencyId.name]: Yup.string().optional(),
  [timeSign.name]: Yup.number().required(timeSign.errorMsg),
  [certificate.name]: Yup.string().required(certificate.errorMsg),
  [signer.name]: Yup.string().required(signer.errorMsg),
  [firstTime.name]: Yup.string().required(firstTime.errorMsg),
  [caseAccounting.name]: Yup.string().required(caseAccounting.errorMsg),
  [checkbox1.name]: Yup.string().required(checkbox1.errorMsg),
  [supplementaryForThe.name]: Yup.string()
    .matches(/^\d+$/, supplementaryForThe.invalidMsg)
    .required(supplementaryForThe.errorMsg),
  [taxCalculationPeriod.name]: Yup.number().required(taxCalculationPeriod.errorMsg),
  [taxId1.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxId1.invalidMsg)
    .required(taxId1.errorMsg),
  [taxpayerName.name]: Yup.string().required(taxpayerName.errorMsg),
});

export default validation;
